import { render } from "./GeoRestrictionsPage.vue?vue&type=template&id=38390357"
import script from "./GeoRestrictionsPage.vue?vue&type=script&lang=js"
export * from "./GeoRestrictionsPage.vue?vue&type=script&lang=js"

import "./GeoRestrictionsPage.vue?vue&type=style&index=0&id=38390357&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__